module.exports = __webpack_public_path__ + "static/media/ic_player_volume_on.c0f43cae.svg";